import {APIService} from "./APIService";

export class QuickNodeAuthService {
    static basePath = "/QuickNodeAuth";

    static getToken = (): Promise<string> => {
        return APIService.requests.get<string>(`${this.basePath}`);
    }
}
